<script>
import 'vue-select/dist/vue-select.css'
import Multiselect from 'vue-multiselect'
import { axiosGetPost } from '@router/axiosGetPost'

export default {
  name: 'HarborDelete',
  props: {
    harborId: { type: [String, Number], default: null },
  },
  components: {
    Multiselect,
  },
  data() {
    return {
      loadingData: false,
      harborNew: null,
      harborsList: [],
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      axiosGetPost('get', '/cargofive/harbors/simple_list').then((response) => {
        this.harborsList = response.data
        return response
      })
    },
    deleteHarbor() {
      axiosGetPost('post', '/cargofive/harbors/delete', {
        harbor_id: this.harborId,
        new_id: this.harborNew.id,
      }).then((response) => {
        this.loadingData = true
        if (response.success) {
          this.$toastr.s(
            'Started delete process. It should disappear reloading soon.'
          )
        } else {
          this.$toastr.e('Attention. Error ')
        }
        this.loadingData = false
        this.$emit('update_view')
        this.$emit('close_modal')
        return response
      })
    },
    customLabel({ id, name }) {
      return `${id} — ${name}`
    },
  },
}
</script>

<template>
  <div>
    <div
      v-if="loadingData"
      class="row align-items-center justify-content-center"
      style="height: 300px"
    >
      <div class="col-12 col-md-8 text-center">
        <b-spinner
          label="Loading..."
          variant="secondary"
          class="ml-3"
        ></b-spinner>
      </div>
    </div>
    <div v-else>
      <div class="form-group w-100">
        <div class="col-md-12 row">
          <div class="col-md-12">
            <label class="mb-1" for="default"
              >Select a harbor to substitute the one to delete:
            </label>
            <multiselect
              v-model="harborNew"
              :options="harborsList"
              placeholder="Select one "
              label="name"
              :custom-label="customLabel"
              track-by="name"
            ></multiselect>
          </div>

          <div class="col-md-12 row">
            <div class="col-md-12">
              <hr />
            </div>
          </div>
          <div class="col-md-12 row">
            <div class="col-md-12">
              <b-button
                variant="primary"
                class="form-control col-md-4"
                @click="deleteHarbor()"
                >Delete</b-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
